import Block from 'lqa-ui/lib/Components/Block';
import ButtonIcon from 'lqa-ui/lib/Components/ButtonIcon';
import Overlay from 'lqa-ui/lib/Components/Overlay';
import LayoutOverlay from 'lqa-ui/lib/Layouts/Overlay';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TutorialVideoList } from './TutorialVideoList';
import { useHistory } from 'react-router-dom';

export const TutorialVideoButton = () => {
    const history = useHistory();

    const { t } = useTranslation();
    const [openTutorialVideoOverlay, setTutorialVideoOpenOverlay] = React.useState<boolean>(false);

    return (
        <React.Fragment>
            <Overlay
                isOpen={openTutorialVideoOverlay}
                layout="focusview"
                doClose={() => {

                }}
            >
                <LayoutOverlay
                    outsideClickClose={true}
                    outsideClickClosefn={
                        () => {
                            setTutorialVideoOpenOverlay(false);
                        }
                    }
                    title={t(`general.Support Videos`)}
                    size="wide"
                    isFocusOnFirstButton={true}
                    buttonIcons={[
                        {
                            icon:'close',
                            onClick: () => {
                                setTutorialVideoOpenOverlay(false);
                            },
                        },
                    ]}
                >
                    <div className="alternate-blocks">
                        <Block>
                            <TutorialVideoList setTutorialVideoOpenOverlay={setTutorialVideoOpenOverlay}/>
                        </Block>
                    </div>
                </LayoutOverlay>

            </Overlay>
            <ButtonIcon 
                loading={false}
                onClick={(e) => {
                    setTutorialVideoOpenOverlay(true);
                }}
                className={'color-white size-larger'}
                icon="qlogo"
                size="large"
                style={{ 
                    float: 'right',
                    position: 'fixed',
                    bottom: '40px',
                    right:'40px',
                    backgroundColor: '#133857',
                    borderRadius:'50%',
                    color:'white',
                    boxShadow: '2px 2px 3px #999',
                    zIndex: 12,
                }}
            />
        </React.Fragment>
    );
};
